import { Component, Input, OnInit } from '@angular/core';

import { AimoDeposit, AimoOrderEntry, PaymentMode } from '../../../../model/cart.model';

@Component({
    selector: 'aimo-cart-item-deposits',
    templateUrl: './aimo-cart-item-deposits.component.html',
    standalone: false
})
export class AimoCartItemDepositsComponent implements OnInit {
    @Input() paymentMode: PaymentMode;
    entry: AimoOrderEntry;
    @Input() alreadyOrdered = false;

    taxRates: string;

    constructor() {}

    ngOnInit(): void {
        this.init();
    }

    private init() {
        this.taxRates = this.getDepositTaxRates(this.entry?.deposits);
    }

    @Input() set aimoEntry(e: AimoOrderEntry) {
        this.entry = e;
        this.init();
    }

    private getDepositTaxRates(deposits: AimoDeposit): string {
        return deposits?.taxes?.map((tax) => tax.rate).join(', ');
    }
}
